import { initialize as initializeUtilities } from '@coldandgoji/utilities'
import { initialize as initializeAuthentication } from '@coldandgoji/svelte-authentication'
import Application from '@components/Application.svelte'

const DEBUG = {
  '@coldandgoji/svelte-algolia': false,
  '@coldandgoji/svelte-authentication': false,
  '@coldandgoji/svelte-firebase': false,
  '@coldandgoji/svelte-form': false,
  '@coldandgoji/svelte-router': false,
  '@coldandgoji/utilities': false,
  '@core/initialize': false,
  '@core/stores': false,
  '@page/userLogout': false,
}

const CONFIGURATION = {
  APPLICATION_ENVIRONMENT: ENV.APPLICATION_ENVIRONMENT,
  APPLICATION_HASH: ENV.APPLICATION_HASH,
  APPLICATION_VERSION: ENV.APPLICATION_VERSION,
  DEBUG: DEBUG,
  ENDPOINT_USER_RECOVER: ENV.ENDPOINT_USER_RECOVER,
  ENDPOINT_USER_RESET: ENV.ENDPOINT_USER_RESET,
  ENDPOINT_USER_VERIFY: ENV.ENDPOINT_USER_VERIFY,
  FIREBASE_API_KEY: ENV.FIREBASE_API_KEY,
  FIREBASE_APP_ID: ENV.FIREBASE_APP_ID,
  FIREBASE_AUTH_DOMAIN: ENV.FIREBASE_AUTH_DOMAIN,
  FIREBASE_DATABASES: ENV.FIREBASE_DATABASES,
  FIREBASE_DATABASE_URL: ENV.FIREBASE_DATABASE_URL,
  FIREBASE_DATASTORES: ENV.FIREBASE_DATASTORES,
  FIREBASE_MESSAGING_SENDER_ID: ENV.FIREBASE_MESSAGING_SENDER_ID,
  FIREBASE_PROJECT_ID: ENV.FIREBASE_PROJECT_ID,
  FIREBASE_REMOTE_CONFIG: ENV.FIREBASE_REMOTE_CONFIG,
  FIREBASE_STORAGE_BUCKET: ENV.FIREBASE_STORAGE_BUCKET,
  SENTRY_DSN: ENV.SENTRY_DSN,
}

const initialize = async () => {
  await initializeUtilities( CONFIGURATION )
  await initializeAuthentication( CONFIGURATION )

  // eslint-disable-next-line no-new
  new Application( {
    target: document.body,
  } )
}

initialize()
